import { GraphQlResponse } from 'providers/tanstack-query/response'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { UPDATE_AD_UNIT_PRODUCT_ENABLED_FOR_TABLE } from './api/mutation'
import { Data, Variables } from './api/types'
import { SwitchVariables, UseSwitchAdUnitProduct } from './types'

export const useSwitchAdUnitProduct = (): UseSwitchAdUnitProduct => {
  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_AD_UNIT_PRODUCT_ENABLED_FOR_TABLE,
  })

  const mapper = ({ id, product, value }: SwitchVariables): Variables => ({
    enabledValue: value,
    id,
    productType: product,
  })

  const update = async (variables: SwitchVariables): Promise<GraphQlResponse<Data>> =>
    (await mutateAsync({
      input: mapper(variables),
    })) as GraphQlResponse<Data>

  return { update }
}
